











































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/types";
import GeneralUtilsHelper from "@/utils/generalUtils";
import numUtils from "@/utils/numUtils";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class PaymentInfo extends Vue {
  @Getter(types.GETTER_INFO_BY_OFFER_DATA)
  private infoByOffer: any;
  @Getter(types.GETTER_CURRENT_INS_USER_INFO)
  private currentInsUserInfo: any;
  @Getter(types.GETTER_PRO_EXTRA_PERCENTAGE)
  private vipExtraPercentage: any;
  @Prop({
    default: () => {
      return null;
    }
  })
  private offer?: any;
  @Prop({
    default: "iap"
  })
  private payWay?: string;

  get displayEffect() {
    return typeof this.infoData.effect === "number"
      ? this.offer.kind.indexOf("vip") > -1
        ? `${this.format(this.infoData.effect)} ${
            this.infoData.effect > 1 ? "Months" : "Month"
          }`
        : this.offer.kind.indexOf("subs") > -1
        ? "1 Week"
        : this.format(this.infoData.effect)
      : this.infoData.effect;
  }

  get rewardText() {
    return this.offer.kind.indexOf("vip") > -1
      ? `+ ${this.format(this.infoData.reward_effect)} ${
                    this.infoData.reward_effect > 1 ? "Months" : "Month"
                    }`
      : `+ ${this.format(this.infoData.reward_effect)}`;
  }

  get unitText() {
    return this.offer.kind.indexOf("vip") > -1 ||
      this.offer.kind.indexOf("subs") > -1
      ? ""
      : this.infoData.unit;
  }

  get userPicShow() {
    if (
      this.offer.kind.indexOf("vip") > -1 ||
      this.isEmptyAccount ||
      this.offer.kind.indexOf("coin") > -1
    ) {
      return false;
    } else {
      return true;
    }
  }

  get isVip() {
    return GeneralUtilsHelper.isVip();
  }

  // 计算出vip额外的添加 规则： 比例*总额 向下取整
  get vipReward() {
    return Math.floor(
      this.vipExtraPercentage *
        (Number(this.displayEffect) + Number(this.infoData.reward_effect)) *
        0.01
    );
  }

  // 临时屏蔽掉stripe的vip奖励
  get showVipReward() {
    return this.payWay !== "card";
  }

  get vipIconShow() {
    if (this.offer.kind.indexOf("vip") > -1) {
      return true;
    } else {
      return false;
    }
  }

  get isCoins() {
    return this.offer.kind.indexOf("coin") > -1;
  }

  get isLuckyCoins() {
    return this.offer.kind.indexOf("lucky_coin") > -1;
  }

  get format() {
    return numUtils.format;
  }

  get isEmptyAccount() {
    return GeneralUtilsHelper.isEmptyAccount();
  }

  get isLoginUser() {
    return GeneralUtilsHelper.isLoginUser();
  }

  get rewardShow() {
    return this.infoData.reward_effect ? true : false;
  }

  get unitShow() {
    return this.infoData.unit !== "" && this.infoData.unit;
  }

  get infoData() {
    return this.infoByOffer(this.offer, this.payWay);
  }

  get type_name() {
    return this.infoData.type_name === "SubsFollower"
      ? this.format(this.infoData.effect) + " Followers / Day"
      : this.infoData.type_name === "SubsLike"
      ? this.format(this.infoData.effect) + " Likes / New Post"
      : this.infoData.type_name;
  }

  private mounted() {
    console.log("info form offer is", this.infoData);
  }
}
